import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/core/api/auth/auth.service';

export const accessGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const user = authService.user();

    if (!user) {
        router.navigate(['/login']);
        return false;
    }

    // Handle permissions
    const permissionData = route.data['permission'] as string | string[];
    let requiredPermissions: string[] = [];

    if (Array.isArray(permissionData)) {
        requiredPermissions = permissionData;
    } else if (typeof permissionData === 'string') {
        requiredPermissions = permissionData
            .split(',')
            .map((p) => p.trim())
            .filter((p) => p.length > 0);
    }

    // Check permissions if specified
    if (requiredPermissions.length > 0) {
        const hasAnyPermission = requiredPermissions.some((permission) => authService.hasPermission(permission));

        if (!hasAnyPermission) {
            console.log('Access denied - user does not have any of the required permissions');
            router.navigate(['/forbidden']);
            return false;
        }
    }

    // Handle roles
    const roleData = route.data['roles'] as string | string[];
    let requiredRoles: string[] = [];

    if (Array.isArray(roleData)) {
        requiredRoles = roleData;
    } else if (typeof roleData === 'string') {
        requiredRoles = roleData
            .split(',')
            .map((r) => r.trim())
            .filter((r) => r.length > 0);
    }

    // Check roles if specified
    if (requiredRoles.length > 0) {
        const hasAnyRole = requiredRoles.some((role) => user?.current_role == role);

        if (!hasAnyRole) {
            console.log('Access denied - user does not have any of the required roles');
            router.navigate(['/forbidden']);
            return false;
        }
    }

    return true;
};
